import { useMemo } from 'react';
import { Survey } from '@rossum/api-client/surveys';
import { getUnsafe } from '../../../../lib/helpers';
import { getNumber } from '../../helpers';
import { useSubmitSurvey } from '../../hooks/useSubmitSurvey';

export const useSurveyActions = (survey: Survey, surveyPlacement: string) => {
  const submitSurvey = useSubmitSurvey();
  return useMemo(() => {
    return {
      /** Used for counting how many times survey has been skipped  */
      increaseSkipCount: () =>
        submitSurvey(
          {
            surveyId: survey.id,
            surveyPatchModel: {
              additionalData: {
                ...(typeof survey.additionalData === 'object'
                  ? survey.additionalData
                  : {}),
                skipCount:
                  getNumber(getUnsafe(survey.additionalData, 'skipCount')) + 1,
                surveyPlacement,
              },
            },
          },
          true
        ),
      /** Used for submitting survey answers */
      answer: (answers: { value: unknown }[]) =>
        submitSurvey(
          {
            surveyId: survey.id,
            surveyPatchModel: {
              // probably not needed here
              additionalData: {
                ...(typeof survey.additionalData === 'object'
                  ? survey.additionalData
                  : {}),
                surveyPlacement,
              },
              answers,
            },
          },
          true
        ),
    } as const;
  }, [submitSurvey, survey.additionalData, survey.id, surveyPlacement]);
};
